export enum CategoryQuestion {
  myOrder = 1,
  information,
  pay,
  delivery,
  highSeason,
  guarantee,
  tireFittingAndDisks,
  seasonalStorage,
  autoService,
  productQuestions,
  loyaltyProgram,
  operationQuestions,
  actionsQuestions,
  conflictResolution,
  wheelPainting,
  argonWelding,
  corporateService,
  wheelAlignment,
  ar,
  refillingConditioner,
  freeTireFitting,
  cabinFilter,
  oilFilter,
  playt,
  airFilter,
  brakePads,
  sparkPlugs,
  fuelFilter,
  tireRepair,
  balancingTire,
  brakeFluid,
  brakeDisc,
  pressureSensor,
  chassis,
  catalytic,
  tireReStudding,
  beltReplacement,
  faqLk,
  adjustment,
}

export interface DataQuestion {
  title: string;
  text: string;
  type: number;
}

export interface QuestionSchema {
  questionList: DataQuestion[];
  activeQuestion: number;
  isLoaded: boolean;
}
